function topic_hillslope_community(){
	var rain_object = {}, 
		coor_object = {}, 
		region_sta_data_object = {},
		table_modal_html = "",
		table_abc_modal_html = "",
		table_html = 
			'<thead class="thead-dark">' +
				'<tr>' +
					'<th class="hillsploe-topic-th" rowspan="2">行政區</th>' +
					'<th rowspan="2">社區</th>' +
					'<th rowspan="2">社區分級</th>' +
					'<th rowspan="2">綜合風險</th>' +
					'<th class="text-center" colspan="2" rowspan="1">鄰近雨量站觀測</th>' +
				'</tr>' +
				'<tr>' +
					'<th>時雨量</th>' +
					'<th>24小時累積</th>' +
				'</tr>' +
			'</thead>' +
			'<tbody></tbody>',
		table_pinlin_html = "",
		abc_distribution = {
			"A級": {
				name: "A級社區",
				color: "purple",
				y: 0
			},
			"B級": {
				name: "B級社區",
				color: "blue",
				y: 0
			},
			"C級": {
				name: "C級社區",
				color: "brown",
				y: 0
			}
		},
		abc_number = 0
	raw_data["雨量站"].forEach(function(element){
		rain_object[element.STID] = element;
	})
	raw_data["山坡地風險社區"].forEach(function(element){
		var this_town_name = element.district
		if (abc_distribution[element.level_abc]) {
			table_abc_modal_html += `
				<tr>
					<td>${this_town_name}</td>
					<td>${element.name}</td>
					<td>${element.level_abc}</td>
				</tr>`
			abc_distribution[element.level_abc].y += 1
			abc_number += 1
		}
		if (region_sta_data_object[this_town_name] == undefined) {
			region_sta_data_object[this_town_name] = {"低風險": 0, "中風險": 0, "高風險": 0, "其他": 0}
		}
		region_sta_data_object[this_town_name][element.level_risk] += 1;
		coor_object[element.name] = [element.lat, element.lon]
	})
	raw_data["坪林分隊水保觀測"].features.forEach(function(element, index){
		var id_index = String(index + 1)
		var obs_column = '<td>-</td><td>-</td>'
		if (element.properties.data) {
			obs_column = `
				<td>${element.properties.data[`ETI-${id_index}A`].timestamp.slice(0,16)}</td>
				<td>${(element.properties.data[`ETI-${id_index}A`].value / 3600).toFixed(2)}° / ${(element.properties.data[`ETI-${id_index}B`].value / 3600).toFixed(2)}°</td>`
		}
		table_pinlin_html += `
			<tr>
				<td>${element.properties.description}</td>
				${obs_column}
			</tr>`
		coor_object[element.properties.description] = [element.geometry.coordinates[1], element.geometry.coordinates[0]]
	})
	Object.keys(region_sta_data_object).forEach(eachRegion => {
		table_modal_html += `
			<tr>
				<td>${eachRegion}</td>
				<td>${region_sta_data_object[eachRegion]["高風險"]}處</td>
				<td>${region_sta_data_object[eachRegion]["中風險"]}處</td>
				<td>${region_sta_data_object[eachRegion]["低風險"]}處</td>
				<td>${region_sta_data_object[eachRegion]["其他"]}處</td>
				<td>${region_sta_data_object[eachRegion]["其他"] + region_sta_data_object[eachRegion]["低風險"] + region_sta_data_object[eachRegion]["中風險"] + region_sta_data_object[eachRegion]["高風險"]}處</td>
			</tr>`
	})
	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("山坡地社區")
		}, false) +
		'<div class="row">' +
			'<div class="col-12 mb-1">' +
				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>山坡地社區列表<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
			        '</div>'+
			        '<div class="slider-card-content">'+
						'<p class="font-weight-bold m-0">' +
							'山坡地社區綜合風險統計圖<select class="ml-1" id="region-sta-chart-selector" style="font-size: .7rem;"><option value="number">數量統計</option><option value="number_percent">百分比分布</option></select>' + 
							'<button class="btn btn-sm btn-success py-0 float-right" type="button" id="community_prediction_modal_table_trig">清單檢視</button>' +
						'</p>'+
			        	'<div class="region-number-sta-chart w-100 mb-1 h-300" id="region_number_sta"></div>' +
						'<div class="region-number-sta-chart w-100 mb-1 h-300 d-none" id="region_number_percent_sta"></div>'+
						'<p class="font-weight-bold m-0">' +
							'全市山坡地社區ABC分級(共' + abc_number + '處)' +
							'<button class="btn btn-sm btn-success py-0 float-right" type="button" id="community_prediction_modal_abc_table_trig">清單檢視</button>' +
						'</p>'+
			        	'<div class="w-100 mb-1 h-300" id="abc_number_sta"></div>'+
						'<label class="font-weight-bold m-0">山坡地社區查詢表</label><br>'+
						'<div class="input-group input-group-sm mb-2">'+
						  	'<div class="input-group-prepend">'+
						    	'<label class="input-group-text">種類篩選</label>'+
						  	'</div>'+
						  	'<select class="custom-select" id="community_prediction_table_trig">'+
						  		'<option value="全部" selected>全部</option>'+
						  		'<option value="abc">具備ABC分級</option>'+
								'<option value="iot">具備物聯網(IoT)設備</option>'+
						  	'</select>'+
						'</div>'+
						'<table class="table table-sm topic_table nowrap datatable-scrollx" id="community_prediction_table">' +
							table_html +
		            	'</table>' +
			        '</div>' +
		        '</div>'+

				// '<div>'+
				// 	'<div class="slider-card-head p-2">'+
				// 		'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>山坡地社區列表(具物聯網設備)<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
			    //     '</div>'+
			    //     '<div class="slider-card-content">'+
				// 		'<table class="table table-sm topic_table nowrap datatable-scrollx w-100" id="community_iot_table">' +
				// 			'<thead class="thead-dark">' +
				// 				'<tr>' +
				// 					'<th class="hillsploe-topic-th" rowspan="2">行政區</th>' +
				// 					'<th rowspan="2">社區</th>' +
				// 					'<th rowspan="2">感測器示警</th>' +
				// 					'<th class="text-center" colspan="2" rowspan="1">鄰近雨量站觀測</th>' +
				// 				'</tr>' +
				// 				'<tr>' +
				// 					'<th>時雨量</th>' +
				// 					'<th>24小時累積</th>' +
				// 				'</tr>' +
				// 			'</thead>' +
				// 			'<tbody></tbody>' +
		        //     	'</table>' +
			    //     '</div>' +
		        // '</div>'+

				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>坡地自動監測<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
			        '</div>'+
			        '<div class="slider-card-content">'+
						'<table class="table table-sm topic_table nowrap w-100" id="community_auto_monitor">' +
							'<thead class="thead-dark">' +
								'<tr >' +
									'<th class="text-center">行政區</th>' +
									'<th class="text-center">名稱</th>' +								
									'<th class="text-center">傾斜儀(x/y)</th>' +
								'</tr>' +
							'</thead>' +
							'<tbody></tbody>' +
		            	'</table>' +
			        '</div>' +
		        '</div>'+
				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>坪林分隊水保觀測<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
			        '</div>'+
			        '<div class="slider-card-content">'+
						'<table class="table table-sm table-pointer table-bordered nowrap w-100" id="pinlin_iot_table">' +
							'<thead class="thead-dark">' +
								'<tr>' +
									'<th>設備名稱</th>' +
									'<th>觀測時間</th>' +
									'<th>傾斜計(x/y)</th>' +
								'</tr>' +
							'</thead>' +
							'<tbody>' +
								table_pinlin_html + 
							'</tbody>' +
		            	'</table>' +
			        '</div>' +
		        '</div>'+
				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>山坡地社區歷史災情檢索<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
			        '</div>'+
			        '<div class="slider-card-content">'+
			        	'<label class="font-weight-bold m-0">查詢條件</label><br>'+
						'<div class="input-group input-group-sm">'+
						  	'<div class="input-group-prepend">'+
						    	'<label class="input-group-text">選擇災情</label>'+
						  	'</div>'+
						  	'<select class="custom-select" id="community_event_selector">'+
							  	'<option value="2021,2022" selected>近一年</option>'+
								'<option value="2019,2022">近三年</option>'+
						  	'</select>'+
						'</div>'+
						'<button type="button" class="btn btn-success btn-sm btn-block mt-2 mb-3" id="community_event_trig">查詢</button>'+
						'<div id="community_event_content"></div>'+
			        '</div>' +
		        '</div>'+
				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>UAV空拍影像(水保署)</h5>' +
			        '</div>'+
			        '<div class="slider-card-content" id="uav_image_content"></div>' +
		        '</div>'+
				'<div style="height: 260px;">'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>人工邊坡示警系統(地礦中心)</h5>' +
			        '</div>'+
			        '<div class="slider-card-content" id="gsmma_image_content">'+
						'<p>介接地礦中心「降雨山崩即時系統」，由降雨量評估山崩潛勢之即時風險示警系統</p>'+
						'<img src="images/landslide_risk_definition.png" class="img-fluid" alt="山崩風險定義">'+
					'</div>' +
		        '</div>'+
			'</div>'+
		'</div>'
	);
	
	$("#region-sta-chart-selector").change(function(){
		$(".region-number-sta-chart").toggleClass("d-none")
	})

	$("#community_prediction_modal_table_trig").click(function(){
		modal_open(`
			<p class="mb-0">(1)綜合風險意義：根據新北市工務局定義，綜合風險為採用崩塌風險分級以及現場調查得到社區總分進行綜合風險評判，綜合風險高的為列入後續監測社區優先建議對象</p>
			<p class="mb-0">(2)山坡地社區定義：山坡地社區定義及說明系參考內政部營建署準則，詳細內容可參照<a href="https://www.cpami.gov.tw/filesys/file/chinese/dept/br2/br107070521.pdf" target="_blank"><i class="fas fa-mouse-pointer ml-2"></i>連結檔案</a></p>
			<p>(3)其他說明：系統上呈現之山坡地社區清單為新北市針對有篩選調查之社區總數</p>
			<table class="table text-center" id="community_prediction_modal_table">
				<thead class="thead-dark">
					<tr>
						<th>行政區</th>
						<th>高風險</th>
						<th>中風險</th>
						<th>低風險</th>
						<th>其他</th>
						<th>總計</th>
					</tr>
				</thead>
				<tbody>
					${table_modal_html}
				</tbody>
			</table>`,
			"各行政區山坡地社區綜合風險數量統計",
			function(){
				$('#community_prediction_modal_table').DataTable({
					"searching": false,
					"paging": false,
					"order": [[ 1, "desc" ]],
					"columnDefs": [
						{ type: 'formatted-num', targets: 1 },
						{ type: 'formatted-num', targets: 2 },
						{ type: 'formatted-num', targets: 3 }
					]
				})
			}
		)
	})

	$("#community_prediction_modal_abc_table_trig").click(function(){
		modal_open(`
			<p>分級意義：根據內政部營建署訂定之山坡地住宅社區安全檢查紀錄表，檢查技師依社區現況紀錄並進行分級（A、B、C級），代表社區的維護管理及處理等級。A級為：應立即委託專業技師或團隊進行深入鑑定工作，並提出改善措施；B級為：持續加強監測；C級為：注意維護，並自行檢視設施狀況。</p>
			<table class="table text-center" id="community_prediction_modal_abc_table">
				<thead class="thead-dark">
					<tr>
						<th>行政區</th>
						<th>社區名稱</th>
						<th>分級</th>
					</tr>
				</thead>
				<tbody>
					${table_abc_modal_html}
				</tbody>
			</table>`,
			"各山坡地社區ABC分級清單",
			function(){
				$('#community_prediction_modal_abc_table').DataTable({
					"searching": false,
					"paging": false,
					"order": [[ 2, "asc" ]]
				})
			}
		)
	})

	$(".topic_table tbody").on("click", "tr", function(){
		var this_index = $(this).find("td").eq(1).html();
		map.setView(coor_object[this_index], 18);
	})

	$("#pinlin_iot_table tbody").on("click", "tr", function(){
		var this_index = $(this).find("td").eq(0).html();
		map.setView(coor_object[this_index], 18);
	})

	// iot設備社區列表
	var iot_list_table = "",
		iot_alert_object = {},
		iot_alert_data = ajax_call(publicPath + "/napi/obs/hillslopecommunity/iot_device_stn_alert"),
		filterIot = true
	iot_alert_data.forEach(el => {
		iot_alert_object[el.properties.name] = "正常"
		Object.values(el.properties.warning_status).forEach(value => {
			if (value !== "正常") {
				iot_alert_object[el.properties.name] = "異常"
			}
		})
	})
	raw_data["山坡地風險社區"].forEach(function(element){
		filterIot = element.obs_sensor
		let rain_info = {
			hour: "-",
			hour24: "-"
		}
		try {
			rain_info.hour = rain_value_processing(rain_object[element.rainstn_refer].RAIN)
			rain_info.hour24 = rain_value_processing(rain_object[element.rainstn_refer].HOUR_24)
		} catch (e) {}
		if (filterIot) {
			iot_list_table +=
				'<tr class="p-cursor">' + 
					'<td>' + element.district + '</td>' +
					'<td>' + element.name + '</td>' +
					'<td class="text-center">' + null_Converter(iot_alert_object[element.name]) + '</td>' +
					'<td class="text-center">' + rain_info.hour +'</td>' +
					'<td class="text-center">' + rain_info.hour24 +'</td>' +
				'</tr>'
		}
	})
	if ($('#community_iot_table tbody').html() !== "") {
		$('#community_iot_table').DataTable().destroy()
	}
	$('#community_iot_table tbody').html(iot_list_table)
	$('#community_iot_table').DataTable({
		"order": [[ 2, "asc" ]],
		"scrollX": true,
		"scrollCollapse": true    
	})

	// 自動監測列表
	let auto_monitor_list = ""
	const community_auto_monitor = ajax_call("geojson/community_auto_monitor.json") 
	const auto_monitor_data = community_auto_monitor.map(i => ({ ...raw_data["山坡地風險社區"].find(el => el.name == i.name), ...i }))
	auto_monitor_data.forEach(el => {
		auto_monitor_list +=
		'<tr class="p-cursor">' + 
			'<td class="text-center">' + el.district + '</td>' +
			'<td class="text-center">' + el.name + '</td>' +
			'<td class="text-center">' + el.x_mean + ' / ' + el.y_mean + '</td>' +
		'</tr>'
	})
	if ($('#community_auto_monitor tbody').html() !== "") {
		$('#community_auto_monitor').DataTable().destroy()
	}
	$('#community_auto_monitor tbody').html(auto_monitor_list)
	$('#community_auto_monitor').DataTable({
		"order": [[ 0, "asc" ]],
		"scrollX": true,
		"scrollCollapse": true    
	})

	// 全社區列表
	$("#community_prediction_table_trig").change(function(){
		var all_list_table = "", filterIot = true, value = $(this).val()
		raw_data["山坡地風險社區"].forEach(function(element){
			let rain_info = {
				hour: "-",
				hour24: "-"
			}
			try {
				rain_info.hour = rain_value_processing(rain_object[element.rainstn_refer].RAIN)
				rain_info.hour24 = rain_value_processing(rain_object[element.rainstn_refer].HOUR_24)
			} catch (e) {}
			if (value === "iot") {
				filterIot = element.obs_sensor
			}
			if (value === "abc") {
				filterIot = (element.level_abc === '-') ? false : element.level_abc
			}
			if (filterIot) {
				all_list_table +=
					'<tr class="p-cursor">' + 
						'<td>' + element.district + '</td>' +
						'<td>' + element.name + '</td>' +
						'<td class="text-center">' + element.level_abc +'</td>' +
						'<td class="text-center">' + element.level_risk +'</td>' +
						'<td class="text-center">' + rain_info.hour +'</td>' +
						'<td class="text-center">' + rain_info.hour24 +'</td>' +
					'</tr>'
			}
		})
		if ($('#community_prediction_table tbody').html() !== "") {
			$('#community_prediction_table').DataTable().destroy()
		}
		$('#community_prediction_table tbody').html(all_list_table)
		$('#community_prediction_table').DataTable({
			"order": [[ 0, "desc" ]],
			"scrollX": true,
			"scrollCollapse": true    
		})
	}).trigger("change")

	Object.keys(abc_distribution).forEach(el => {
		if (abc_distribution[el].y === 0) {
			delete abc_distribution[el]
		}
	})

	var level_abc_selected = ''
	pie_chart_advanced({
		renderdiv: "abc_number_sta",
		title: "",
		tooltipPointFormat: "共{point.y}處</b>",
		dataLabelsFormatter: function () { 
		  	return `${this.point.name}: ${(this.point.y)} 處 (${this.point.percentage.toFixed(1)}%)`;
		},
		series: {
			name: "社區分級分布",
			data: Object.values(abc_distribution),
			events: {
				click: (e) => {
					level_abc_selected = e.point.name.slice(0,2) == level_abc_selected ? '' : e.point.name.slice(0,2)
					map.removeLayer(overlay_dataset["山坡地風險社區"]);
					overlay_dataset["山坡地風險社區"] = hillslope_community_layer(undefined, level_abc_selected)[0]
					overlay_dataset["山坡地風險社區"].addTo(map);
				}
			}
		}
	})

	stacked_column_chart({
		div: "region_number_sta",
		data: region_sta_data_object,
		key_name: ["高風險", "中風險", "低風險", "其他"],
		label: ["高風險", "中風險", "低風險", "其他"],
		color: ['red', '#FFBC42', '#00ff23', 'gray'],
		max: 100
	});

	stacked_percent_chart({
		div: "region_number_percent_sta",
		data: region_sta_data_object,
		key_name: ["高風險", "中風險", "低風險", "其他"],
		label: ["高風險", "中風險", "低風險", "其他"],
		color: ['red', '#FFBC42', '#00ff23', 'gray']
	})

	$(".hillslope_class_selector").click(function(){
		var this_option = $(this).html();
		loader_asynchronous(function(){
			var filter_class_condition;
			switch(this_option){
				case "全部":
					filter_class_condition = {
						green: true, yellow: true, red: true
					};
					break;
				case "黃色警戒":
					filter_class_condition = {
						green: false, yellow: true, red: false
					};
					break;
				case "紅色警戒":
					filter_class_condition = {
						green: false, yellow: false, red: true
					};
					break;
			};
			map.removeLayer(overlay_dataset["山坡地風險社區"]);
			overlay_dataset["山坡地風險社區"] = hillslope_community_layer({
				"class": filter_class_condition
			})[0];
			overlay_dataset["山坡地風險社區"].addTo(map);
		});
	});

	$("#community_event_trig").click(function(){
		loader_asynchronous(function(){
			$("#community_event_content").empty();
			var community_event_table_string = "";
			if (raw_data["history_data"] == undefined) {
				raw_data["history_data"] = {"type": "FeatureCollection", "features": []};
				var year_parameter = $("#community_event_selector").val().split(",");
				var history_data = ajax_call(publicPath + "/napi/emis/ntc_all_cases?start=" + year_parameter[0] + "&end=" + year_parameter[1]);
				history_data.forEach(function(element){
					raw_data["history_data"]["features"].push({
						"type": "Feature",
						"geometry": {
					      	"type": "Point",
					      	"coordinates": [parseFloat(element.WGS_X), parseFloat(element.WGS_Y)]
						},
						"properties": {
							"DISA_LOCATION": element.DISA_LOCATION,
							"PRJ_ID": element.PRJ_ID,
							"DISA_NO": element.DISA_NO,
							"DISA_LEVEL": element.DISA_LEVEL,
							"DISA_TYPE": element.DISA_TYPE
						}
					});
				});
			};

			var option_region_name = {}, option_region_string = "", community_object = {};
			raw_data["山坡地風險社區"].forEach(function(element){
				option_region_name[element.district] = 0;
				var result = {};
				var buffered = turf.buffer(turf.point([element.lon, element.lat]), 500, {units: 'meters'});
				var ptsWithin = turf.pointsWithinPolygon(raw_data["history_data"], buffered);
				result["sum_event"] = ptsWithin.features.length;
				result["road_event"] = 0;
				result["slope_event"] = 0;
				result["serious_history"] = "無";
				ptsWithin.features.forEach(function(each_point){
					if (each_point.properties.DISA_LEVEL == "9") {
						result["serious_history"] = "有";
					};
				});
				community_event_table_string +=
					'<tr class="p-cursor">'+
						'<td>' + element.name +'</td>'+
						'<td>' + result["serious_history"] + '</td>'+
						'<td>' + result["sum_event"] + '</td>'+
						'<td>' + element.level_risk +'</td>'+
					'</tr>';
				community_object[element.name] = {
					"region": element.district,
					"serious_history": result["serious_history"],
					"sum_event": result["sum_event"],
					"slope_event": result["slope_event"],
					"road_event": result["road_event"],
					"level_risk": element.level_risk
				};
			});

			Object.keys(option_region_name).forEach(function(each_region){
				option_region_string += '<option value="' + each_region + '">' + each_region + '</option>';
			});

			$("#community_event_content").html(
				'<label class="font-weight-bold m-0">篩選條件</label><br>'+
				'<div class="input-group input-group-sm mb-2">'+
				  	'<div class="input-group-prepend">'+
				    	'<label class="input-group-text">選擇區域</label>'+
				  	'</div>'+
				  	'<select class="custom-select community_event_filter">'+
				  		'<option value="all" selected>全部</option>'+
				  		option_region_string +
				  	'</select>'+
				'</div>'+
				'<table class="table topic_table mb-2" id="community_event_table" width="100%" height="100%">' +
	                '<thead class="thead-dark">' +
	                    '<tr>' +
	                        '<th>社區</th>' +
	                        '<th>曾有嚴重災情</th>' +
	                        '<th>歷史災情總數</th>' +
	                        '<th>綜合風險</th>' +
	                    '</tr>' +
	                '</thead>' +
	                '<tbody>' +
	                	community_event_table_string +
	                '</tbody>' +
	        	'</table>'
			);

		    $('#community_event_table').DataTable({
		        "order": [[ 0, "asc" ]],
		        "searching": true
		    });

			$("#community_event_table tbody").on("click", "tr", function(){
				var this_index = $(this).find("td").eq(0).html();
				map.setView(coor_object[this_index], 18);
			});

			$(".community_event_filter").change(function(){
				loader_asynchronous(function(){
					var filter_list = [], region_condition_boolean;
					community_event_table_string = "";
					$(".community_event_filter").each(function(){
						filter_list.push($(this).val());
					});
		            $('#community_event_table').DataTable().destroy();
		            $("#community_event_table tbody").empty();
					console.log(community_object, filter_list[0])
		            for (var each_community in community_object) {
						if (filter_list[0] == "all") {
							region_condition_boolean = true;
						} else {
							region_condition_boolean = (community_object[each_community].region == filter_list[0]);
						};
		            	if (region_condition_boolean) {
							community_event_table_string +=
								'<tr class="p-cursor">'+
									'<td>' + each_community +'</td>'+
									'<td>' + community_object[each_community]["serious_history"] + '</td>'+
									'<td>' + community_object[each_community]["sum_event"] + '</td>'+
									'<td>' + community_object[each_community]["level_risk"] + '</td>'+
								'</tr>';
		            	}
		            };
		            $("#community_event_table tbody").html(community_event_table_string);
				    $('#community_event_table').DataTable({
				        "order": [[ 0, "desc" ]],
				        "searching": true
				    });
					map.removeLayer(overlay_dataset["山坡地風險社區"]);
					overlay_dataset["山坡地風險社區"] = hillslope_community_layer({
						"region": filter_list[0]
					})[0];
					overlay_dataset["山坡地風險社區"].addTo(map);
				});
			});
		});
	});

	setTimeout(() => {
		$("th.hillsploe-topic-th").click()
	}, 1000)

	// 水保署UAV空拍影像
	ajax_call_async(publicPath + "/napi/obs/hillslopecommunity/swcb/uav/point", 
		function(data){
			var tbody = ""
			var infoObject = {}
			data.forEach(el => {
				infoObject[el.Id] = el
				tbody += `
					<tr>
						<td>${el.Date}</td>
						<td>${el.Title.split("_")[2]}</td>
						<td><button type="button" class="btn btn-link btn-sm" target-id="${el.Id}">檢視</button></td>
					</tr>`
			})
			$("#uav_image_content").html(`
				<label class="font-weight-bold m-0">查詢清單</label><br>
				<table class="table table-sm text-center">
					<thead class="thead-dark">
						<tr>
							<th>日期</th>
							<th>場域</th>
							<th>檢視</th>
						</tr>
					</thead>
					<tbody>
						${tbody}
					</tbody>
				</table>`
			)
		    $('#uav_image_content table').DataTable({
		        "order": [[ 0, "desc" ]],
		        "searching": true
		    })
			$("#uav_image_content table tbody").on("click", "button", function(){
				if (overlay_dataset["temp_map"]) {
					map.removeLayer(overlay_dataset["temp_map"])
				}
				var targetId = $(this).attr("target-id")
				var tileLayerUrl = infoObject[targetId].AccessURL
				map.setView([infoObject[targetId].CenterLatitude, infoObject[targetId].CenterLongitude], 16)
				overlay_dataset["temp_map"] = new L.tileLayer(`${tileLayerUrl}{z}/{y}/{x}.jpg`, {
					pane: "high-zindex-wms-layer"
				})
				map.addLayer(overlay_dataset["temp_map"])
			})
		}, 
		function(){
			
		}
	)
}
